import Vue from 'vue';

export const mutationTypes = {
  startLoading: '[administration] start loading',
  stopLoading: '[administration] stop loading',

  getUserListSuccess: '[administration] get users success',
  getCompanyListSuccess: '[administration] get company success',

  updateUserInList: '[administration] update user in list',

  changeUserNameStart: '[administration] change user name start',
  changeUserNameSuccess: '[administration] change user name success',
  changeUserNameFailure: '[administration] change user name failure',

  clearOffset: '[administration] clear offset',
  changeRouteWatch: '[administartion] change route watch',
};

const mutations = {
  [mutationTypes.startLoading](state) {
    state.isLoading = true;
  },

  [mutationTypes.stopLoading](state) {
    state.isLoading = false;
  },

  [mutationTypes.getUserListSuccess](state, payload) {
    state.isLoading = false;

    if (payload.reload) {
      state.users = [...payload.items];
    } else {
      state.users.push(...payload.items);
    }

    state.count = payload.count;
    state.offset = payload.offset;
  },

  [mutationTypes.getCompanyListSuccess](state, payload) {
    state.isLoading = false;
    state.companyList = payload;
  },

  [mutationTypes.updateUserInList](state, {type, banned, uid, action, new_email}) {
    state.isLoading = false;

    let users = [...state.users];
    let idx = users.findIndex((user) => user.uid === uid);

    if (idx >= 0) {
      let usr = state.users[idx];

      if (type === 'email') {
        usr.email = new_email;
      } else if (type === 'ban') {
        usr.banned = banned;
      } else if (type === 'imp') {
        usr.has_imp_role = action === 'grant';
      } else if (type === 'admin') {
        usr.has_admin_role = action === 'grant';
      } else if (type === 'platform_admin') {
        usr.has_platform_admin_role = action === 'grant';
      }

      Vue.set(state, 'users', users);
    }
  },

  [mutationTypes.changeUserNameStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.changeUserNameSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.changeUserNameFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },

  [mutationTypes.clearOffset](state) {
    state.count = 0;
    state.offset = 0;
  },

  [mutationTypes.changeRouteWatch](state, payload) {
    state.isRouteWatched = payload;
  },
};

export default mutations;
